import React from "react";
import Arrow from "../../assets/icons/Arrow";
var ArrowButton = function (props) {
    var _a;
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: "".concat((_a = props.additionalClass) !== null && _a !== void 0 ? _a : '', " border border-c-purple rounded-full px-3 py-3.5"), onClick: props.onClick },
            React.createElement(Arrow, { color: "none" }))));
};
export default ArrowButton;
